import ApiResourceManager from '../ApiResourceManager';

/**
 * Wolt Drive onboarding for the current company (PROD-491). Super admins and the
 * platform's onboarding managers only — the backend answers 403 to everyone else.
 */
export default class WoltDriveOnboardingManager extends ApiResourceManager {
  getSheetRow = () =>
    this.request({
      method: 'GET',
      url: '/wolt-drive-onboarding/sheet-row',
    });

  verify = (woltDriveVenueId) =>
    this.request({
      method: 'POST',
      url: '/wolt-drive-onboarding/verification',
      data: { wolt_drive_venue_id: woltDriveVenueId },
    });

  activate = ({ woltDriveVenueId, providerPriority }) =>
    this.request({
      method: 'PUT',
      url: '/wolt-drive-onboarding',
      data: { wolt_drive_venue_id: woltDriveVenueId, provider_priority: providerPriority },
    });
}
